import type { EventType } from "app/types/eventType";
import { Component } from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { IconArrowLeft } from "../../../../../../../../components/Icon/Icon";
import "./Header.scss";

type Props = {
  updateUnsummarizedMarketsModalEvent: (...args: Array<any>) => any;
  previousRoute: string | null;
};

class Header extends Component<Props> {
  onClickBack = () => {
    this.props.updateUnsummarizedMarketsModalEvent(null);
  };

  render() {
    // Use previousRoute if available, otherwise fallback to /events
    const backUrl = this.props.previousRoute || "/events";
    return (
      <header className="unsummarized-markets__header">
        <Link to={backUrl} className="back-button" onClick={this.onClickBack}>
          <IconArrowLeft />
          <FormattedMessage
            tagName="span"
            id="global-events-navigation-all-events"
          />
        </Link>
      </header>
    );
  }
}

const mapStateToProps = state => ({
  previousRoute: state.navigationModel.previousRoute,
});

const mapDispatchToProps = (dispatch: any) => {
  return {
    updateUnsummarizedMarketsModalEvent: (event: EventType) =>
      dispatch.competitionListModel.updateUnsummarizedMarketsModalEvent(event),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header) as any;
